// ═══════════════════════════════════════════════════════════════
// ClearView CRM — Donor Welcome Journey Stage Definitions
// Path: src/constants/journeyStages.js
//
// Four stages track a new donor from import through to
// "Donor of Record" (2+ gifts).
// ═══════════════════════════════════════════════════════════════

export const JOURNEY_STAGES = [
  { id: "imported", name: "Imported", color: "#6b7280", icon: "Upload" },
  { id: "card_sent", name: "Card Sent", color: "#0d9488", icon: "Send" },
  { id: "first_gift", name: "First Gift", color: "#f59e0b", icon: "Gift" },
  { id: "donor_of_record", name: "Donor of Record", color: "#10b981", icon: "Award" },
];

export const JOURNEY_STAGE_MAP = Object.fromEntries(
  JOURNEY_STAGES.map((s) => [s.id, s])
);

// Ordered list of stage IDs for advancement logic
export const JOURNEY_STAGE_ORDER = JOURNEY_STAGES.map((s) => s.id);
